export const GROUP_FUNDRAISER_CONSTANTS = {
  ONEHOPE_ACCOUNT_ID: '6c525e6a-9e16-4434-8d7b-76528800e627',
  ONEHOPE_DEALER_ID: 813448,
};

export enum GroupFundraiserTypeEnum {
  Master = 'MASTER',
  Satellite = 'SATELLITE',
}
